// Triggered in Block

import { SAVE_GAME_RESULTS } from '../state-constants/stateConstants';

export const saveGameResults = obj => ({
  type: SAVE_GAME_RESULTS,
  payload: obj,
});



// WEBPACK FOOTER //
// ./src/state-actions/saveGameResults.js